module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "texts"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("SAP Ref: " + _vm._s(_vm.item.clientSapRef))]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("Client Ref: " + _vm._s(_vm.item.clientRef1))])]), _vm._v(" "), _c('ItemImage', {
    attrs: {
      "item": _vm.item
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5193ac26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/catalogue/CatalogueItemDescription.vue
// module id = 3182
// module chunks = 0